import React, { FC } from 'react';

import styles from './FinancialDashboardFormContainer.module.scss';

interface FinancialDashboardFormContainerProps {
  title?: string | JSX.Element;
  subtitle?: string | JSX.Element;
}

const FinancialDashboardFormContainer: FC<FinancialDashboardFormContainerProps> = ({ children, title, subtitle }) => (
  <div className={styles.container}>
    {(title || subtitle) && (
      <div className={styles.header}>
        {title && <h1 className={styles.headerTitle}>{title}</h1>}
        {subtitle && <p className={styles.headerSubtitle}>{subtitle}</p>}
      </div>
    )}
    {children}
  </div>
);

export default FinancialDashboardFormContainer;
